import Skeleton from 'react-loading-skeleton';

export const ProfileDropdownLoader = () => {
  return <Skeleton circle height={40} style={{ opacity: 0.5 }} width={40} />;
};
